import { render, staticRenderFns } from "./knowledgeBase.vue?vue&type=template&id=9e31f04c&scoped=true&"
import script from "./knowledgeBase.vue?vue&type=script&lang=js&"
export * from "./knowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./knowledgeBase.vue?vue&type=style&index=0&id=9e31f04c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e31f04c",
  null
  
)

export default component.exports